import "./index.css";
import type { ReactNode } from "react";
import type { ITooltipProps } from "../../Tooltip/types";
import { Info } from "lucide-react";
import { Typography } from "../../Typography";
import { Tooltip } from "../../Tooltip";
import { cloneWithClassName } from "../../../utils";
import { clsx } from "clsx";

type IProps = {
  icon?: ReactNode;
  title: ReactNode;
  tooltipProps?: Omit<ITooltipProps, "anchor">;
  endContent?: ReactNode;
  className?: string;
};

const renderTitle = (content: ReactNode, className: string) => {
  return (
    cloneWithClassName(content, className) || (
      <Typography
        variant="headline"
        weight="bold"
        text={content}
        className={className}
      />
    )
  );
};

export const CardHeader = ({
  icon,
  title,
  tooltipProps,
  endContent,
  className,
}: IProps) => {
  return (
    <div className={clsx("nuco-card-header", className)}>
      {icon && <div className="nuco-card-header__icon">{icon}</div>}
      {renderTitle(title, "nuco-card-header__title")}
      {tooltipProps && (
        <Tooltip {...tooltipProps}>
          <Info className="nuco-card-header__tooltip-anchor" size="16" />
        </Tooltip>
      )}
      {endContent && <div className="nuco-card-header__end">{endContent}</div>}
    </div>
  );
};
